import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Checkbox
} from 'semantic-ui-react'

const CardHomeMedDetailUX = (props: any) => {
    return(
      <div
        id="CardHomeMedDetailUX-div-0"
        style={{padding: "5px 0"}}>
        <Form
          id="CardHomeMedDetailUX-Form-1">
          <FormGroup
            id="CardHomeMedDetailUX-FormGroup-2"
            inline={true}
            style={{alignItems: "flex-start"}}>
            <FormField
              id="CardHomeMedDetailUX-FormField-3"
              inline={true}
              style={{minWidth: "max-content", paddingRight: "3.5rem", alignItems: "baseline"}}
              width={8}>
              <label
                id="CardHomeMedDetailUX-label-15">
                {`${props.drugDetail?.title || "-"} : `}
              </label>
              <div
                id="CardHomeMedDetailUX-div-18">
                {props.drugDetail?.code || "-"}
              </div>
            </FormField>
            <FormField
              className="--override-disabled --grey"
              id="CardHomeMedDetailUX-FormField-4"
              style={{display: "grid"}}
              width={8}>
              <Checkbox
                checked={props.telepharType ==="INTRA"}
                className="blue"
                disabled={props.disabledCheck || false}
                id="CardHomeMedDetailUX-Checkbox-22"
                label={props.languageUX === "en" ? "Intrahospital Telepharmacy" : "เภสัชกรรมทางไกลภายในโรงพยาบาล"}
                name="INTRA"
                onChange={props.onChangeValue}
                style={{minWidth: "max-content", opacity: 1, textAlign: "left",...(props.showCheck?{}:{opacity:0, pointerEvents: "none"})}}>
              </Checkbox>
              <Checkbox
                checked={props.telepharType==="DELIVERY"}
                className="blue"
                disabled={props.disabledCheck || props.hasDrugTransportNotAllowed || false}
                id="CardHomeMedDetailUX-Checkbox-23"
                label={props.languageUX === "en" ? "Home delivery" : "บริการส่งถึงบ้าน"}
                name="DELIVERY"
                onChange={props.onChangeValue}
                style={{textAlign: "left", marginTop: "0.75rem",...(props.showCheck?{}:{opacity:0, pointerEvents: "none"})}}>
              </Checkbox>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardHomeMedDetailUX-FormGroup-7"
            inline={true}
            style={{marginTop: "-1.7rem", display: "none"}}>
            <FormField
              id="CardHomeMedDetailUX-FormField-8"
              inline={true}
              width={16}>
              <label
                id="CardHomeMedDetailUX-label-19">
                สถานะ : 
              </label>
              <div
                id="CardHomeMedDetailUX-div-20">
                {props.status || ""}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardHomeMedDetailUX-FormGroup-9">
            <FormField
              id="CardHomeMedDetailUX-FormField-10"
              width={16}>
              <div
                id="CardHomeMedDetailUX-div-21">
                {props.itemsElement}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardHomeMedDetailUX-FormGroup-11"
            inline={true}>
            <FormField
              id="CardHomeMedDetailUX-FormField-12"
              style={{flex: 1}}>
            </FormField>
            <FormField
              id="CardHomeMedDetailUX-FormField-13"
              style={{padding:0}}>
              <div
                id="CardHomeMedDetailUX-div-14">
                {props.buttonCall}
              </div>
            </FormField>
          </FormGroup>
        </Form>
      </div>
    )
}

CardHomeMedDetailUX.displayName = "CardHomeMedDetailUX";
export default React.memo(CardHomeMedDetailUX)

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px 0\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"flex-start\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormField-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", paddingRight: \"3.5rem\", alignItems: \"baseline\"}"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\"}"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormGroup-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"-1.7rem\", display: \"none\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormGroup-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormField-10"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormGroup-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormField-12"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-FormField-13"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCall"
        },
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-div-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "`${props.drugDetail?.title || \"-\"} : `"
        },
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-label-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugDetail?.code || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-div-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ : "
        },
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-label-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-div-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "props.itemsElement"
        },
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-div-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Checkbox",
      "parent": 4,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.telepharType ===\"INTRA\""
        },
        "className": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledCheck || false"
        },
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-Checkbox-22"
        },
        "label": {
          "type": "value",
          "value": "เภสัชกรรมทางไกลภายในโรงพยาบาล",
          "valueEN": "Intrahospital Telepharmacy"
        },
        "name": {
          "type": "value",
          "value": "INTRA"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", opacity: 1, textAlign: \"left\",...(props.showCheck?{}:{opacity:0, pointerEvents: \"none\"})}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Checkbox",
      "parent": 4,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.telepharType===\"DELIVERY\""
        },
        "className": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledCheck || props.hasDrugTransportNotAllowed || false"
        },
        "id": {
          "type": "value",
          "value": "CardHomeMedDetailUX-Checkbox-23"
        },
        "label": {
          "type": "value",
          "value": "บริการส่งถึงบ้าน",
          "valueEN": "Home delivery"
        },
        "name": {
          "type": "value",
          "value": "DELIVERY"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"left\", marginTop: \"0.75rem\",...(props.showCheck?{}:{opacity:0, pointerEvents: \"none\"})}"
        }
      },
      "seq": 23,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "memo": true,
  "name": "CardHomeMedDetailUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
